import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSidebarRightShow16Filled(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconSidebarRightShow16Filled"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10 3H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h7zM1 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm6.19 2.232a.5.5 0 0 0-.707-.707L4.362 7.647 4.008 8l.354.354 2.12 2.121a.5.5 0 1 0 .708-.707L5.422 8z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSidebarRightShow16Filled);
